<ng-container *transloco="let t; prefix: 'dashboard_transactions'">
  <div
    class="hidden font-semibold text-xs text-neutral-500 md:flex gap-x-1 items-center"
    *transloco="let t; prefix: 'nav'"
  >
    <button
      routerLink="/home"
      class="btn btn-link p-0 no-underline text-neutral-500"
    >
      <span>{{ t("home") }}</span>
    </button>
    <i class="fa-solid fa-chevron-right"></i>
    <button
      routerLink="/home/transactions"
      class="btn btn-link p-0 no-underline text-neutral-500"
    >
      <span>{{ t("transactions") }}</span>
    </button>
  </div>

  <div
    class="mb-2 flex flex-col items-start md:flex-row md:justify-between md:items-start"
  >
    <span>
      <h1 class="font-extrabold text-4xl">{{ t("title") }}</h1>
      <p>{{ t("subtitle") }}</p>
    </span>
    <div class="flex gap-2 my-3">
      <button
        (click)="recordPayment()"
        class="btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex justify-center items-center size-auto gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
      >
        <i class="fa-solid fa-circle-plus text-2xl"></i>
        <span class="text-sm" *transloco="let t; prefix: 'services'">{{
          t("record_payment")
        }}</span>
      </button>
      <button
        (click)="modalService.open('payment-qr-code')"
        class="btn bg-white dark:bg-base-100 shadow border-1 border-base-100 flex justify-center items-center size-auto gap-3 p-3 rounded-box hover:md:bg-primary hover:md:text-white"
      >
        <span class="size-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            fill="currentColor"
          >
            <path
              d="M1.66037 23.9084C0.744005 23.9084 5.30496e-06 23.1653 5.37058e-06 22.2479C5.43604e-06 21.3327 0.744005 20.5918 1.66037 20.5918L3.97746 20.5918L3.97746 12.6816C3.97746 7.8919 7.87637 4 12.6676 4L16.1433 4C17.0618 4 17.8058 4.74308 17.8058 5.66049C17.8058 6.57571 17.0618 7.31879 16.1433 7.31879L12.6676 7.31879C9.70691 7.31879 7.29819 9.72235 7.29819 12.6816L7.29819 20.5918L13.0211 20.5918L13.0211 18.3887C12.9993 15.6321 15.2138 13.3789 17.9738 13.3528L30.0262 13.3528C32.784 13.3789 34.9985 15.6321 34.9767 18.3887L34.9767 20.5918L40.6996 20.5918L40.6996 12.6729C40.6996 9.72453 38.2975 7.32533 35.3455 7.32097L31.7935 7.31879C30.8771 7.31879 30.1331 6.57571 30.1331 5.66049C30.1353 4.74308 30.8771 4 31.7956 4L35.3498 4.00218C40.1302 4.00654 44.0225 7.89626 44.0225 12.6729L44.0225 20.5918L46.3375 20.5918C47.2538 20.5918 48 21.3327 48 22.2479C48 23.1653 47.2538 23.9084 46.3375 23.9084L1.66037 23.9084ZM17.9727 35.683C16.6527 35.683 15.3851 35.1535 14.4622 34.2099C13.5327 33.2576 13.0178 31.9785 13.02 30.6471L13.02 27.8796C13.0309 27.5549 13.2906 27.2912 13.6156 27.2825L34.3865 27.2825C34.7095 27.2934 34.9691 27.5571 34.9758 27.8796L34.9758 30.6471C34.9996 33.4036 32.7829 35.6547 30.0251 35.683L17.9727 35.683ZM12.6685 43.9993C7.87506 43.9993 3.97833 40.1074 3.97833 35.3199L3.97833 31.1949C3.97833 30.2797 4.72015 29.5344 5.6387 29.5344C6.55506 29.5344 7.29906 30.2797 7.29906 31.1949L7.29906 35.3199C7.29906 38.277 9.70779 40.6827 12.6685 40.6827L16.1441 40.6827C17.0605 40.6827 17.8045 41.4236 17.8045 42.3389C17.8045 43.2563 17.0605 43.9993 16.1441 43.9993L12.6685 43.9993ZM31.7941 44C30.8777 44 30.1337 43.2569 30.1337 42.3395C30.1337 41.4243 30.8756 40.6812 31.7941 40.6812L35.3483 40.679C38.2981 40.6747 40.6981 38.2755 40.6981 35.3271L40.6981 31.1955C40.6981 30.2803 41.4443 29.5351 42.3607 29.5351C43.277 29.5351 44.021 30.2803 44.021 31.1955L44.021 35.3271C44.021 40.1037 40.1308 43.9935 35.3505 43.9978L31.7941 44Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span class="text-sm" *transloco="let t; prefix: 'services'">{{
          t("request_payment")
        }}</span>
      </button>
    </div>
  </div>

  <div class="mt-5 mb-2">
    <h3 class="text-xs md:text-base uppercase">{{ t("today_statistics") }}</h3>
  </div>

  <div
    class="hidden md:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 mb-4"
  >
    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div
          class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
        >
          <i class="fa-solid fa-exchange text-slate-500 text-3xl"></i>
        </div>
        <div class="stat-title text-base dark:text-slate-300 mb-1">
          {{ t("total") }}
        </div>

        @if (loadedTransactions()) {
          <div
            class="stat-value text-4xl leading-none dark:text-slate-300 text-primary"
          >
            {{ this.transactions().length | amountSummary }}
          </div>
        } @else {
          <span class="loading loading-spinner w-9"></span>
        }

        <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                +288 this Month
              </div> -->
      </div>
    </div>

    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div
          class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
        >
          <i class="fa-solid fa-circle-check text-slate-500 text-4xl"></i>
        </div>
        <div class="stat-title text-base dark:text-slate-300 mb-1">
          {{ t("initiated") }}
        </div>

        @if (loadedTransactions()) {
          <div class="stat-value text-4xl text-slate-500 leading-none">
            {{ this.initiatedTransactions() | amountSummary }}
          </div>
        } @else {
          <span class="loading loading-spinner w-9"></span>
        }

        <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                +528 this Month
              </div> -->
      </div>
    </div>

    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div
          class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
        >
          <i class="fa-solid fa-hourglass-clock text-warning text-3xl"></i>
        </div>
        <div class="stat-title text-base dark:text-slate-300 mb-1">
          {{ t("pending") }}
        </div>

        @if (loadedTransactions()) {
          <div class="stat-value text-4xl text-warning leading-none">
            {{ this.pendingTransactions() | amountSummary }}
          </div>
        } @else {
          <span class="loading loading-spinner w-9"></span>
        }
        <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                +1.3M this Month
              </div> -->
      </div>
    </div>

    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div
          class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
        >
          <i class="fa-solid fa-circle-check text-success text-4xl"></i>
        </div>
        <div class="stat-title text-base dark:text-slate-300 mb-1">
          {{ t("confirmed") }}
        </div>
        @if (loadedTransactions()) {
          <div class="stat-value text-4xl text-success leading-none">
            {{ this.confirmedTransactions() | amountSummary }}
          </div>
        } @else {
          <span class="loading loading-spinner w-9"></span>
        }

        <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                +1.3M this Month
              </div> -->
      </div>
    </div>
    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div
          class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
        >
          <i
            class="fa-solid fa-circle-xmark text-slate-400 dark:text-slate-600 text-4xl"
          ></i>
        </div>
        <div class="stat-title text-base dark:text-slate-300 mb-1">
          {{ t("canceled") }}
        </div>

        @if (loadedTransactions()) {
          <div
            class="stat-value text-4xl text-slate-400 dark:text-slate-600 leading-none"
          >
            {{ this.canceledTransactions() | amountSummary }}
          </div>
        } @else {
          <span class="loading loading-spinner w-9"></span>
        }
        <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                +1.3M this Month
              </div> -->
      </div>
    </div>
  </div>

  <div
    class="md:hidden stats shadow bg-white dark:bg-base-100 rounded-box cursor-pointer hover:md:opacity-90 w-full mb-4"
    (click)="showTransactionBreakdown()"
  >
    <div class="stat p-3 md:p-4">
      <div class="stat-figure dark:text-slate-300 text-primary">
        <i class="fa-solid fa-exchange text-slate-500 text-3xl"></i>
      </div>
      <div class="stat-title text-xs md:text-base dark:text-slate-300 mb-1">
        {{ t("total") }}
      </div>
      @if (loadedTransactions()) {
        <div
          class="stat-value flex gap-1 text-3xl md:text-4xl leading-none dark:text-slate-300 text-primary"
        >
          {{ this.transactions().length | amountSummary }}
        </div>
      } @else {
        <span class="loading loading-spinner w-5"></span>
      }

      <div class="text-[0.6rem] text-slate-400 mt-1">
        {{ t("click_for_breakdown") }}
      </div>
    </div>
  </div>

  <div class="collapse collapse-arrow bg-white dark:bg-base-100 mb-2">
    <input type="checkbox" name="transactions" [(ngModel)]="filterIsOpen" />
    <div class="collapse-title font-normal">{{ t("filters") }}</div>
    <div class="collapse-content bg-base-200">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-2 my-2">
        <label class="form-control">
          <div class="label">
            <span class="label-text">{{ t("status_filter") }}</span>
          </div>
          <select
            #status="ngModel"
            [(ngModel)]="statusFilter"
            class="select select-bordered select-sm"
          >
            <option disabled selected>{{ t("pick_a_status") }}</option>
            <option [value]="transactionStatus.ALL">
              {{ t("all") }}
            </option>
            <option [value]="transactionStatus.INITIATED">
              {{ t("initiated") }}
            </option>
            <option [value]="transactionStatus.PENDING">
              {{ t("pending") }}
            </option>
            <option [value]="transactionStatus.CONFIRMED">
              {{ t("confirmed") }}
            </option>
            <option [value]="transactionStatus.CANCELED">
              {{ t("canceled") }}
            </option>
          </select>
        </label>

        <label class="form-control">
          <div class="label">
            <span class="label-text">{{ t("account_filter") }}</span>
          </div>
          <select
            #accounts="ngModel"
            [(ngModel)]="accountsFilter"
            class="select select-bordered select-sm"
          >
            <option disabled selected>{{ t("pick_an_account") }}</option>
            <option [value]="'all'">{{ t("all") }}</option>
            <option value="null">{{ t("no_account") }}</option>

            @for (
              account of businessPaymentAccounts();
              track $index;
              let count = $count
            ) {
              @if (account.label) {
                <option [value]="account?.id">
                  {{ account.label }}
                </option>
              } @else {
                <option [value]="account?.id">
                  {{ account.payment_provider?.display_name }} ({{
                    account.number_display
                  }})
                </option>
              }
            }
          </select>
        </label>
      </div>
    </div>
  </div>

  <div class="card rounded-box bg-white dark:bg-base-200 !py-0">
    <div class="card-body p-0">
      <qwiko-transaction-list
        class="w-full"
        [transactions]="transactions()"
        [loading]="loading()"
        [(selectedTransaction)]="selectedTransaction"
        [statusFilter]="statusFilter()"
        [accountsFilter]="accountsFilter()"
      ></qwiko-transaction-list>
    </div>
  </div>
</ng-container>

<qwiko-transactions-breakdown
  [transactions]="transactions()"
></qwiko-transactions-breakdown>

<qwiko-all-services></qwiko-all-services>
